var render, staticRenderFns
import script from "./UnitPartial.vue?vue&type=script&lang=js&"
export * from "./UnitPartial.vue?vue&type=script&lang=js&"
import style0 from "./UnitPartial.vue?vue&type=style&index=0&id=5208e3d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5208e3d2",
  null
  
)

export default component.exports